import React from 'react';
import {Link} from 'react-router-dom';
import {Requests, Businesses} from 'api';
import {LoadingPage} from 'components/loading-page';
import {ShowIf} from 'components/utils';
import {NoContent} from 'components/no-content';
import RequestItem from './RequestItem.jsx';
import './_Request.scss';
import {connect} from 'react-redux';

class RequestsContainer extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: [],
      count: 0,
      skip: 0,
      limit: 10,
      isLoading: false,
      business: this.props.business
    };
    this.loadMore = this.loadMore.bind(this);
  }

  componentDidMount() {
    this.setState({isLoading: true});
    Requests.actions.count.request().then((response) => {
      this.setState({count: response.data.count, isLoading: false});
      this.getList();
    }).catch((error) => {
      this.setState({isLoading: false});
    });
  }

  componentWillReceiveProps(nextProps) {
    console.log(nextProps);
    if (nextProps.business != this.state.business) {
      this.setState({
        business: nextProps.business
      });

      this.getList();
    }
  }

  getList() {
    if (!this.state.business) {
      return;
    }
    this.setState({isLoading: true});
    const params = {
      id: this.state.business.id,
      filter: {
        include: 'product',
        limit: this.state.limit,
        skip: this.state.skip
      }
    };
    Businesses.actions.requests.request(params).then(response => {
      let requests = this.state.data;
      response.data.map((item, idx) => {
        requests.push(item);
      });
      this.setState({data: requests, isLoading: false});
    }).catch(() => {
      this.setState({isLoading: false});
    });
  }

  loadMore() {
    this.setState({skip: this.state.skip + 10}, () => {
      this.getList();
    });
  }

  render() {
    const {isLoading, skip, limit, count} = this.state;
    return (
      <section className="list-request">
        <LoadingPage isShow={isLoading} />
        <ShowIf condition={this.state.data.length > 0}>
          <div className='list-request-wrap'>
            {
              this.state.data.map((item, idx) => {
                return (
                  <RequestItem key={idx} {...item}/>
                );
              })
            }
          </div>
        </ShowIf>
        <ShowIf condition={!isLoading && this.state.data.length == 0}>
          <NoContent content='Không có yêu cầu nào' height={724}/>
        </ShowIf>
        <ShowIf condition={!isLoading && this.state.data.length > 0 && (skip + limit) < count}>
          <div className="btn-see-more-wrap">
            <button className="btn-see-more" onClick={this.loadMore}>Xem Thêm</button>
          </div>
        </ShowIf>
      </section>
    );
  }
}


const bindStateToProps = state => {
  let business = {};
  if (state.myBusinesses && state.myBusinesses.mainBusiness) {
    business = state.myBusinesses.mainBusiness;
  }

  return {
    auth: state.auth,
    business: business
  }
}

export default connect(bindStateToProps)(RequestsContainer);



// WEBPACK FOOTER //
// ./components/my-business/requests/RequestsContainer.jsx